import React from "react";
import App from "../ui/container/App";
import {ErrorBoundary} from "config/ErrorBoundary";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import loadable from '../util/loadable'
import PrivateRoute from "router/PrivateRoute";
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
//region common
const PlatformFrame = loadable(() => import("scenes/common/PlatformFrame/PlatformFrame"));
const Portal = loadable(() => import("../scenes/common/Portal/Portal"));
const Console = loadable(() => import("scenes/common/Console/Console"));
const ConsoleHome = loadable(() => import("scenes/common/ConsoleHome/ConsoleHome"));

//endregion
//region user
const Register = loadable(() => import("scenes/UserService/Register/Register"));
const RegisterPrivate = loadable(() => import("scenes/UserService/Register/RegisterPrivate"));
const RegisterSuccess = loadable(() => import("scenes/UserService/Register/RegisterSuccess"));
const VerifyRegister = loadable(() => import("scenes/UserService/Register/VerifyRegister"));
const VerifyFail = loadable(() => import("scenes/UserService/Register/VerifyFail"));
const VerifySuccess = loadable(() => import("scenes/UserService/Register/VerifySuccess"));
const ModifyUserPassword = loadable(() => import("scenes/UserService/ModifyUserPassword/ModifyUserPasswordComponent"));
const ComponentParent = loadable(() => import("../scenes/common/Console/ComponentParent"));
const EditUserDetailsPage = loadable(() => import("scenes/UserService/User/EditUserDetailsPage"));
const UserDetailsPage = loadable(() => import("scenes/UserService/User/UserDetailsPage"));
const EditUserCertifyPage = loadable(() => import("scenes/UserService/User/EditUserCertifyPage"));
// const UserList = loadable(() => import("scenes/UserService/UsersPage/UserListPage"));
const UserList = loadable(() => import("scenes/UserService/UsersPage/UserListPagePublic"));
const UserListPrivate = loadable(() => import("scenes/UserService/UsersPage/UserListPagePrivate"));
const AdminEditUserPage = loadable(() => import("scenes/UserService/User/AdminEditUserPage"));
const VerifyUserDetail = loadable(() => import("scenes/UserService/VerifyUserDetail/VerifyUserDetailPage"));
const RegisterWithInvitationCode = loadable(() => import("scenes/UserService/RegisterWithInvitationCode/RegisterWithInvitationCode"));
const EditUserJob = loadable(() => import("scenes/UserService/EditUserJob/EditUserJobInformationPage"));
//endregion
//region enterprise
const EnterpriseList = loadable(() => import("scenes/UserService/EnterprisesPage/EnterpriseListPage"));
const VerifyEnterpriseDetail = loadable(() => import("scenes/UserService/VerifyEnterpriseDetail/VerifyEnterpriseDetailPage"));
const EditEnterpriseDetailsPage = loadable(() => import("scenes/UserService/Enterprise/EditEnterpriseDetailsPage"));
const CompanyPrivilege = loadable(() => import("scenes/UserService/RoleList/CompanyPrivilege"));
const VerifyEnterpriseAuthList = loadable(() => import("scenes/UserService/VerifyEnterpriseAuth/VerifyEnterpriseAuthListPage"));
const CreateEnterpriseDetails = loadable(() => import("scenes/UserService/Enterprise/CreateEnterpriseDetailsPage"));
//endregion
//region role
const RoleList = loadable(() => import("scenes/UserService/RoleList/RoleList"));
const PrivilegeRoleConfig = loadable(() => import("scenes/UserService/RoleList/PrivilegeRoleConfig"));
const UserRoleConfig = loadable(() => import("scenes/UserService/RoleList/UserRoleConfig"));
const AssignUserRole = loadable(() => import("scenes/UserService/RoleList/AssignUserRole"));
const AssignPlatformUserRole = loadable(() => import("scenes/UserService/RoleList/AssignPlatformUserRole"));
const UserRoleAdd = loadable(() => import("scenes/UserService/RoleList/UserRoleAdd"));
//platform role
const PlatformRoleList = loadable(() => import("scenes/UserService/PlatformRoleList/RoleList"));
const PlatformPrivilegeRoleConfig = loadable(() => import("scenes/UserService/PlatformRoleList/PrivilegeRoleConfig"));
const PlatformUserRoleConfig = loadable(() => import("scenes/UserService/PlatformRoleList/UserRoleConfig"));
const PlatformUserRoleAdd = loadable(() => import("scenes/UserService/PlatformRoleList/UserRoleAdd"));



const CreateUserCertifyPage = loadable(() => import("scenes/UserService/User/CreateUserCertifyPage"));
const InitializeTenantSpace = loadable(() => import("scenes/Space/InitializeTenantSpace/InitializeTenantSpacePage"));
const SmsMessage = loadable(() => import("scenes/UserService/Message/SmsMessage"));
//endregion
const ConsoleApplicationPage = loadable(() => import("../scenes/ConsoleApplicationPage/ConsoleApplicationPage"));
const DataShowTempPage = loadable(() => import("../scenes/DataShowTempPage/DataShowTempPage"));
const UserInvitationPage = loadable(() => import("../scenes/UserInvitationPage/UserInvitationPage"));
const UserInvitationPagePrivate = loadable(() => import("../scenes/UserInvitationPage/private/RegisterPrivateInvitation"));
//region bigdata
const LhdTest = loadable(() => import("../scenes/Algorithm/lhdTest/LhdTest"));
const TrainedModelPage = loadable(() => import("../scenes/Algorithm/wzjTest/TrainedModelPage"));
const ProjectList = loadable(() => import("../scenes/Algorithm/Project/ProjectTable/ProjectList"));
const ProjectPanel = loadable(() => import("../scenes/Algorithm/Project/ProjectWorkbench/ProjectPanel"));
const Poc = loadable(() => import("../scenes/Algorithm/lhdTest/MoveWord/Poc"));
const DataSetManagementComponent = loadable(() => import("../scenes/Algorithm/linbaichuanTest/DataSetManagement/DataSetManagementComponent"));
const JointTest = loadable(() => import("../scenes/Algorithm/lhdTest/JointTest"));
const ProjectPoc = loadable(() => import("../scenes/Algorithm/lhdTest/ProjectPoc/ProjectPoc"));
const Feedback = loadable(() => import("../scenes/common/Portal/components/AffixComponent/Feedback"));
//endregion
//region account
const PersonAccountManagement = loadable(() => import("../scenes/Account/AccountManagement/PersonAccountManagementPage"));
const EnterpriseAccountManagement = loadable(() => import("../scenes/Account/AccountManagement/EnterpriseAccountManagementPage"));
const SolutionComponent = loadable(() => import("../scenes/Solution/SolutionComponent"));
const MyHubPage = loadable(() => import("../scenes/IframePage/MyHubPage"));
const ExtensionPage = loadable(() => import("../scenes/IframePage/ExtensionPage"));
const EmployeeListPage = loadable(() => import("../scenes/UserService/EmployeeList/EmployeeListPage"));
const EmployeeListPagePrivate = loadable(() => import("../scenes/UserService/EmployeeList/private/EmployeeListPagePrivate"));
const EmployeeVerifyUserRole = loadable(() => import("../scenes/UserService/EmployeeList/EmployeeVerifyUserRole"));
const HelpHome = loadable(() => import("../scenes/Help/HelpHome"));
const HelpDetails = loadable(() => import("../scenes/Help/HelpDetails"));
const HelpFilter = loadable(() => import("../scenes/Help/HelpFilter"));
const NewsComponent = loadable(() => import( "../scenes/News/NewsComponent"));
const PrivacyPolicy = loadable(() => import( "../scenes/UserService/Register/PrivacyPolicy"));
const PhoneFarmerPrivacyPolicy = loadable(() => import( "../scenes/UserService/Privacy/PhoneFarmerPrivacyPolicy"));
const Login = loadable(() => import( "../scenes/UserService/Login/Login"));
const ResetUserPasswordComponent = loadable(() => import( "../scenes/UserService/ModifyUserPassword/ResetUserPasswordComponent"));
//region footer
const AboutCascloudwing = loadable(() => import( "../scenes/common/Portal/FooterPages/AboutCascloudwing/AboutCascloudwing"));
const ContactUs = loadable(() => import( "../scenes/common/Portal/FooterPages/ContactUs/ContactUs"));
const PreSaleConsulting = loadable(() => import( "../scenes/common/Portal/FooterPages/PreSaleConsulting/PreSaleConsulting"));
const CurrentUserStatistics = loadable(() => import( "../scenes/UserService/Login/CurrentUserStatistics"));
const LoginWithMobile = loadable(() => import( "../scenes/UserService/Login/LoginWithMobile"));
const HistoryUserStatistics = loadable(() => import( "../scenes/UserService/Login/HistoryUserStatistics"));
const AdviceFeedback = loadable(() => import( "../scenes/common/Portal/FooterPages/AdviceFeedback/AdviceFeedback"));
const LegalAgreements = loadable(() => import( "../scenes/common/Portal/FooterPages/LegalAgreements/LegalAgreements"));
const Solutions = loadable(() => import( "../scenes/common/Portal/FooterPages/Solutions/Solutions"));
const CustomerCase = loadable(() => import( "../scenes/common/Portal/FooterPages/CustomerCase/CustomerCase"));
const Nhi = loadable(() => import( "../scenes/common/Portal/FooterPages/CustomerCase/Nhi"))
const Rgb = loadable(() => import( "../scenes/common/Portal/FooterPages/CustomerCase/Rgb"))
const Sysmed = loadable(() => import( "../scenes/common/Portal/FooterPages/CustomerCase/Sysmed"))
const Announcement = loadable(() => import( "../scenes/common/Portal/FooterPages/Announcement/Announcement"))
const UserLoginStatistics = loadable(() => import( "../scenes/UserService/Login/UserLoginStatistics"));
const HelpManagement = loadable(() => import( "../scenes/Help/HelpManagement"));
// const UserRoleApply = loadable(() => import( "../scenes/UserService/RoleList/UserRoleApply"));
const EnterpriseRoleApply = loadable(() => import( "../scenes/UserService/RoleList/EnterpriseRoleApply"));
const PlatformRoleApply = loadable(() => import( "../scenes/UserService/RoleList/PlatformRoleApply"));
const VerifyUserRoleApply = loadable(() => import( "../scenes/UserService/RoleList/VerifyUserRoleApply"));
const FindBackUsername = loadable(() => import( "../scenes/UserService/ModifyUserPassword/FindBackUsername"));
const DepartmentAndJobManagement = loadable(() => import("../scenes/UserService/DepartmentAndJob/DepartmentAndJobManagement"));
const PaymentConfirmationManagement = loadable(() => import("../scenes/Account/AccountManagement/PaymentConfirmationManagement"))
//endregion

const Exception403 = loadable(() => import("../scenes/common/Exception/403"));

const Exception404 = loadable(() => import("../scenes/common/Exception/404"));

const Exception415 = loadable(() => import("../scenes/common/Exception/415"));

const Exception500 = loadable(() => import("../scenes/common/Exception/500"));

// import MessageCenter from "scenes/UserService/Message/MessgeCenter";
// const MessageCenter = Loadable({
//   loader: () => import("../scenes/UserService/Message/MessgeCenter"),
//   loading: Loading
// });
//
// // import MessageNew from "scenes/UserService/Message/MessageNew";
// const MessageNew = Loadable({
//   loader: () => import("../scenes/UserService/Message/MessageNew"),
//   loading: Loading
// });
//
// // import MessageSent from "scenes/UserService/Message/MessageSent";
// const MessageSent = Loadable({
//   loader: () => import("../scenes/UserService/Message/MessageSent"),
//   loading: Loading
// });
//
// // import MessageDetail from "scenes/UserService/Message/MessageDetail";
// const MessageDetail = Loadable({
//   loader: () => import("../scenes/UserService/Message/MessageDetail"),
//   loading: Loading
// });
const MessageCategoryPage = loadable(() => import("../scenes/MessageManagement/MessageCategory/MessageCategoryPage"));
const MessageTypePage = loadable(() => import("../scenes/MessageManagement/MessageType/MessageTypePage"));
const MessageGroupPage = loadable(() => import("../scenes/MessageManagement/MessageGroup/MessageGroupPage"));
const MessageSentPage = loadable(() => import("../scenes/MessageManagement/MessageSent/MessageSentPage"));
const MessageCenterPage = loadable(() => import("../scenes/MessageManagement/MessageCenter/MessageCenterPage"));
//endregion
//region tenant
const IncreaseQuota = loadable(() => import("../scenes/Space/IncreaseQuota/IncreaseQuotaPage"));

const DeployMarketAppPage = loadable(() => import("../scenes/Application/DeployMarketApp/DeployMarketAppPage"));

const SpaceAppsManagementPage = loadable(() => import("../scenes/SpaceAppsManagement/SpaceAppsManagementPage"));

const PlatformSpaceManagementPage = loadable(() => import("../scenes/DeploymentAppsManagement/PlatformSpaceManagementPage"));

const EnterpriseSpaceManagementPage = loadable(() => import("../scenes/DeploymentAppsManagement/EnterpriseSpaceManagementPage"));

const AppConfigAndConditionPage = loadable(() => import("../scenes/AppConfigAndConditionPage/AppConfigAndConditionPage"));

const ApplyTsdatabaseSpacePage = loadable(() => import("../scenes/Space/ApplyTsdatabaseSpace/ApplyTsdatabaseSpacePage"));

const ShowDatabaseServicePage = loadable(() => import("../scenes/Space/DatabaseService/ShowDatabaseServicePage"));

const NamespaceVerifyPage = loadable(() => import("../scenes/Space/NamespaceVerify/NamespaceVerifyPage"));

const ApplyBigdataQuotaPage = loadable(() => import("../scenes/Space/ApplyBigdataQuota/ApplyBigdataQuotaPage"));
//endregion

//region application
const ApplicationMarketPortalPage = loadable(() => import("../scenes/Application/ApplicationMarketPortal/ApplicationMarketPortalPage"));

const ApplicationMarketListPage = loadable(() => import("../scenes/Application/ApplicationMarketList/ApplicationMarketListPage"));

const ApplicationMarketViewPage = loadable(() => import("../scenes/Application/ApplicationMarketView/ApplicationMarketViewPage"));

const ApplicationMarketManagementPage = loadable(() => import("../scenes/Application/ApplicationMarketManagement/ApplicationMarketManagementPage"));

const ApplicationCategoryPage = loadable(() => import("../scenes/Application/ApplicationCategory/ApplicationCategoryPage"));

const ApplicationVerifyPage = loadable(() => import("../scenes/Application/ApplicationVerify/ApplicationVerifyPage"));

const ApplicationVerifyPlatformPage = loadable(() => import("../scenes/Application/ApplicationVerifyPlatform/ApplicationVerifyPlatformPage"));

const ApplicationManagementEnterprisePage = loadable(() => import("../scenes/Application/ApplicationManagementEnterprise/ApplicationManagementEnterprisePage"));

const ApplicationManagementPrivatePage = loadable(() => import("../scenes/Application/ApplicationManagementPrivate/ApplicationManagementPrivatePage"));

const ApplicationManagementPlatformPage = loadable(() => import("../scenes/Application/ApplicationManagementPlatform/ApplicationManagementPlatformPage"));

const ApplicationListPage = loadable(() => import("../scenes/Application/ApplicationList/ApplicationListPage"));

const ApplicationAddPage = loadable(() => import("../scenes/Application/ApplicationAdd/ApplicationAddPage"));

const ApplicationEditPage = loadable(() => import("../scenes/Application/ApplicationEdit/ApplicationEditPage"));

const ModuleAddPage = loadable(() => import("../scenes/Application/ApplicationEdit/ModuleAdd/ModuleAddPage"));

const ModuleEditPage = loadable(() => import("../scenes/Application/ApplicationEdit/ModuleEdit/ModuleEditPage"));

const VersionAddPage = loadable(() => import("../scenes/Application/VersionAdd/VersionAddPage"));

const VersionEditPage = loadable(() => import("../scenes/Application/VersionEdit/VersionEditPage"));

const ResourceAddPage = loadable(() => import("../scenes/Application/ResourceAdd/ResourceAddPage"));

const ResourceEditPage = loadable(() => import("../scenes/Application/ResourceEdit/ResourceEditPage"));

//endregion

//region algorithm
const AlgorithmCategoryPage = loadable(() => import("../scenes/Algorithm/AlgorithmCategory/AlgorithmCategoryPage"));

const AlgorithmListPage = loadable(() => import("../scenes/Algorithm/AlgorithmList/AlgorithmListPage"));

const AlgorithmAddPage = loadable(() => import("../scenes/Algorithm/AlgorithmAdd/AlgorithmAddPage"));

const AlgorithmEditPage = loadable(() => import("../scenes/Algorithm/AlgorithmEdit/AlgorithmEditPage"));

const AlgorithmViewPage = loadable(() => import("../scenes/Algorithm/AlgorithmView/AlgorithmViewPage"));

const AlgorithmLibraryPage = loadable(() => import("../scenes/Algorithm/AlgorithmLibrary/AlgorithmLibraryPage"));

const AlgorithmManagementPage = loadable(() => import("../scenes/Algorithm/AlgorithmManagement/AlgorithmManagementPage"));

const VerifyAlgorithmListPage = loadable(() => import("../scenes/Algorithm/VerifyAlgorithm/VerifyAlgorithmListPage"));

const VerifyAlgorithmDetailPage = loadable(() => import("../scenes/Algorithm/VerifyAlgorithm/VerifyAlgorithmDetailPage"));
//endregion

//region menu
const MenuManagementPage = loadable(() => import("../scenes/Menu/MenuManagement/MenuManagementPage"));

const MenuEnterpriseManagementPage = loadable(() => import("../scenes/Menu/MenuManagement/MenuEnterpriseManagementPage"));

const RoleConfigManagementPage = loadable(() => import("../scenes/Menu/RoleConfigManagement/RoleConfigManagementPage"));

const RoleConfigEnterpriseManagementPage = loadable(() => import("../scenes/Menu/RoleConfigManagement/RoleConfigEnterpriseManagementPage"));
//endregion

//region equipment
const EquipmentCertifyListPage = loadable(() => import("../scenes/Equipment/EquipmentCertifyManagement/EquipmentCertifyList/EquipmentCertifyListPage"));

const EquipmentCertifyRegisterPage = loadable(() => import("../scenes/Equipment/EquipmentCertifyManagement/EquipmentCertifyRegister/EquipmentCertifyRegisterPage"));

const EquipmentCertifyDestroyPage = loadable(() => import("../scenes/Equipment/EquipmentCertifyManagement/EquipmentCertifyDestroy/EquipmentCertifyDestroyPage"));

const EquipmentCertifyVerifyPage = loadable(() => import("../scenes/Equipment/EquipmentCertifyManagement/EquipmentCertifyVerify/EquipmentCertifyVerifyPage"));

const EquipmentTypeListPage = loadable(() => import("../scenes/Equipment/EquipmentType/EquipmentTypeList/EquipmentTypeListPage"));

const EquipmentTypeAddPage = loadable(() => import("../scenes/Equipment/EquipmentType/EquipmentTypeAdd/EquipmentTypeAddPage"));

const EquipmentTypeEditPage = loadable(() => import("../scenes/Equipment/EquipmentType/EquipmentTypeEdit/EquipmentTypeEditPage"));

const EquipmentListPage = loadable(() => import("../scenes/Equipment/EquipmentManagement/EquipmentList/EquipmentListPage"));

const EquipmentAddPage = loadable(() => import("../scenes/Equipment/EquipmentManagement/EquipmentAdd/EquipmentAddPage"));

const EquipmentEditPage = loadable(() => import("../scenes/Equipment/EquipmentManagement/EquipmentEdit/EquipmentEditPage"));

const EquipmentDetailPage = loadable(() => import("../scenes/Equipment/EquipmentManagement/EquipmentDetail/EquipmentDetailPage"));

const EquipmentConfigPage = loadable(() => import("../scenes/Equipment/EquipmentManagement/EquipmentConfig/EquipmentConfigPage"));

const EquipmentDataViewPage = loadable(() => import("../scenes/Equipment/EquipmentManagement/EquipmentDataView/EquipmentDataViewPage"));

const EquipmentLogPage = loadable(() => import("../scenes/Equipment/EquipmentManagement/EquipmentLog/EquipmentLogPage"));

const EquipmentBackupListPage = loadable(() => import("../scenes/Equipment/EquipmentBackup/EquipmentBackupList/EquipmentBackupListPage"));

const EquipmentBackupConfigPage = loadable(() => import("../scenes/Equipment/EquipmentBackup/EquipmentBackupConfig/EquipmentBackupConfigPage"));

const EquipmentBackupDetailPage = loadable(() => import("../scenes/Equipment/EquipmentBackup/EquipmentBackupDetail/EquipmentBackupDetailPage"));

//endregion

// const MessageRoleAssignPage = loadable(() => import("../scenes/Message/MessageRoleAssign/MessageRoleAssignPage"));
//
// const MessageTypePage = loadable(() => import("../scenes/Message/MessageType/MessageTypePage"));
//
// const MessageSentPage = loadable(() => import("../scenes/Message/MessageSent/MessageSentPage"));
//
// const MessageCreate = loadable(() => import("../scenes/Message/MessageSent/MessageCreate"));
//
// const ReceiveMessagePage = loadable(() => import("../scenes/Message/ReceiveMessage/ReceiveMessagePage"));
//
// const MessageDetailPage = loadable(() => import("../scenes/Message/MessageDetailPage"));
// IoT NEW
const Product = loadable(() => import("../scenes/IoT/Product/Product"));

const Device = loadable(() => import("../scenes/IoT/Device/Device"));

const DeviceDetail = loadable(() => import("../scenes/IoT/Device/DeviceDetail"));

const Group = loadable(() => import("../scenes/IoT/Group/Group"));

const DataPush = loadable(() => import("../scenes/IoT/DataTransfer/DataPush"));


const PlatformResourceMonitorPage = loadable(() => import("../scenes/PlatFormResourceMonitor/PlatformResourceMonitorPage"));

export default (onLogout) => {
  return (
    <div>
      <App>
        <Router>
          <CacheSwitch>
            <Route exact path="/" component={Portal}/>
            <Route path="/common" render={(props) => <Common {...props} onLogout={onLogout}/>}/>
            <CacheRoute  path="/console"  render={(props) => <Consoles {...props}/>}/>

            {/*endregion*/}
            {/*region 大数据*/}
            <Route path="/algorithm/trained-model" component={TrainedModelPage}/>
            <Route path="/algorithm/lhdTest" component={LhdTest}/>
            <Route path="/algorithm/joint" component={JointTest}/>
            <Route path="/algorithm/poc" component={Poc}/>
            <Route path="/algorithm/projectPoc" component={ProjectPoc}/>
            {/*region 大数据*/}
            <Route path="algorithm-category" component={AlgorithmCategoryPage}/>
            <Route path="algorithm-list" component={AlgorithmListPage}/>
            <Route path="algorithm-add" component={AlgorithmAddPage}/>
            <Route path="algorithm-edit" component={AlgorithmEditPage}/>
            <Route path="algorithm-view" component={AlgorithmViewPage}/>
            <Route path="algorithm-management" component={AlgorithmManagementPage}/>
            <Route path="verify-algorithm-list" component={VerifyAlgorithmListPage}/>
            <Route path="verify-algorithm-detail" component={VerifyAlgorithmDetailPage}/>
            {/*region 咨询反馈*/}
            <Route path="/feedback" component={Feedback}/>
            {/*region 咨询反馈*/}
            {/*region 隐私政策*/}
            <Route path="privacy-policy" component={PrivacyPolicy}/>
            <Route path="phone-farmer-privacy-policy" component={PhoneFarmerPrivacyPolicy}/>
            {/*region 隐私政策*/}
            <Route path="login-validate" component={LoginWithMobile}/>
            {/*region 异常*/}
            <Route path="/exception/403" component={Exception403}/>
            <Route path="/exception/404" component={Exception404}/>
            <Route path="/exception/415" component={Exception415}/>
            <Route path="/exception/500" component={Exception500}/>
            {/*保持在最后 不要修改*/}
            <Route path=":domain" component={Portal}/>
            {/*{renderRoutes(routers)}*/}
          </CacheSwitch>
        </Router>
      </App>
    </div>
  )
}
const Common = ({match, onLogout, ...rest}) => (
  <PlatformFrame {...rest}>
    <Switch>
      {/*region 注册页面*/}
      <RouteWithErrorBoundary path={`${match.url}/register`} component={Register}/>
      <RouteWithErrorBoundary path={`${match.url}/registerPrivate`} component={RegisterPrivate}/>
      <RouteWithErrorBoundary path={`${match.url}/register-success`} component={RegisterSuccess}/>
      <RouteWithErrorBoundary path={`${match.url}/register-verify`} component={VerifyRegister}/>
      <RouteWithErrorBoundary path={`${match.url}/register-with-invitation-code`} component={RegisterWithInvitationCode}/>
      <RouteWithErrorBoundary path={`${match.url}/verify-fail`} component={VerifyFail}/>
      <RouteWithErrorBoundary path={`${match.url}/verify-success`} component={VerifySuccess}/>
      <RouteWithErrorBoundary path={`${match.url}/logout`} onEnter={onLogout}/>
      <RouteWithErrorBoundary path={`${match.url}/feedback`} component={Feedback}/>
      {/*endregion*/}

      {/*region 登录页面*/}
      <RouteWithErrorBoundary path={`${match.url}/login`} component={Login}/>
      {/*endregion*/}

      {/*region 重置密码与找回用户名*/}
      <RouteWithErrorBoundary path={`${match.url}/reset-password`} component={ResetUserPasswordComponent}/>
      <RouteWithErrorBoundary path={`${match.url}/find-back-username`} component={FindBackUsername}/>
      {/*endregion*/}

      {/*region 应用市场*/}
      <RouteWithErrorBoundary path={`${match.url}/application-market-portal`} component={ApplicationMarketPortalPage}/>
      <RouteWithErrorBoundary path={`${match.url}/application-market-list`} component={ApplicationMarketListPage}/>
      <RouteWithErrorBoundary path={`${match.url}/application-market-view`} component={ApplicationMarketViewPage}/>
      {/*endregion*/}

      {/*region 租户资源*/}
      <RouteWithErrorBoundary path={`${match.url}/application-market-deploy`} component={DeployMarketAppPage}/>
      {/*endregion*/}

      {/*region 用户职务信息修改*/}

      {/*endregion*/}

      {/*region 算法*/}
      <RouteWithErrorBoundary path={`${match.url}/algorithm-library`} component={AlgorithmLibraryPage}/>
      {/*endregion*/}
      {/*region 大数据展示页面*/}
      <RouteWithErrorBoundary path={`${match.url}/bigdata-show`} component={DataShowTempPage}/>
      {/*endregion*/}
      {/*region 新闻页面*/}
      <RouteWithErrorBoundary path={`${match.url}/news`} component={NewsComponent}/>
      {/*endregion*/}

      {/*region 解决方案页面*/}
      <RouteWithErrorBoundary path={`${match.url}/solution`} component={SolutionComponent}/>
      {/*endregion*/}

      {/*region 帮助文档*/}
      <RouteWithErrorBoundary path={`${match.url}/help-home`} component={HelpHome}/>
      <RouteWithErrorBoundary path={`${match.url}/help-details`} component={HelpDetails}/>
      <RouteWithErrorBoundary path={`${match.url}/help-filter`} component={HelpFilter}/>
      {/*endregion*/}

      {/*region 页脚*/}
      <RouteWithErrorBoundary path={`${match.url}/about-cascloudwing`} component={AboutCascloudwing}/>
      <RouteWithErrorBoundary path={`${match.url}/contact-us`} component={ContactUs}/>
      <RouteWithErrorBoundary path={`${match.url}/pre-sale-consulting`} component={PreSaleConsulting}/>
      <RouteWithErrorBoundary path={`${match.url}/advice-and-feedback`} component={AdviceFeedback}/>
      <RouteWithErrorBoundary path={`${match.url}/legal-agreements`} component={LegalAgreements}/>
      <RouteWithErrorBoundary path={`${match.url}/solutions`} component={Solutions}/>
      <RouteWithErrorBoundary path={`${match.url}/customer-case`} component={CustomerCase}/>
      <RouteWithErrorBoundary path={`${match.url}/nhi`} component={Nhi}/>
      <RouteWithErrorBoundary path={`${match.url}/rgb`} component={Rgb}/>
      <RouteWithErrorBoundary path={`${match.url}/sysmed`} component={Sysmed}/>
      <RouteWithErrorBoundary path={`${match.url}/announcement`} component={Announcement}/>
    </Switch>
  </PlatformFrame>
);

const Consoles = ({match,...rest}) => (
  <PrivateRoute {...rest}>
    <Console {...rest}>
      <CacheSwitch>
        {/*<RouteWithErrorBoundary path={`${match.url}/message-role-assign`} component={MessageRoleAssignPage}/>*/}
        {/*<RouteWithErrorBoundary path={`${match.url}/message-type`} component={MessageTypePage}/>*/}
        {/*<RouteWithErrorBoundary path={`${match.url}/message-sent`} component={MessageSentPage}/>*/}
        {/*<RouteWithErrorBoundary path={`${match.url}/message-receive`} component={ReceiveMessagePage}/>*/}
        {/*<RouteWithErrorBoundary path={`${match.url}/message-create`} component={MessageCreate}/>*/}
        {/*<RouteWithErrorBoundary path={`${match.url}/message-detail-page/:id/:type`} component={MessageDetailPage}/>*/}

        {/*<RouteWithErrorBoundary path={`${match.url}/message-center`} component={MessageCenter}/>*/}
        {/*<RouteWithErrorBoundary path={`${match.url}/message-detail`} component={MessageDetail}/>*/}
        {/*<RouteWithErrorBoundary path={`${match.url}/message-new`} component={MessageNew}/>*/}

        <CacheRoute path={`${match.url}/message-category`} cacheKey="message-category"component={ComponentParent}/>
        <CacheRoute path={`${match.url}/message-type`} cacheKey="message-type"component={ComponentParent}/>
        <CacheRoute path={`${match.url}/message-group`} cacheKey="message-group"component={ComponentParent}/>
        <CacheRoute path={`${match.url}/message-sent`} cacheKey="message-sent"component={ComponentParent}/>
        <CacheRoute  path={`${match.url}/message-center`} cacheKey="message-center" component={ComponentParent}/>

        <CacheRoute path={`${match.url}/message-category-enterprise`} cacheKey="message-category-enterprise" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/message-type-enterprise`} cacheKey="message-type-enterprise" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/message-group-enterprise`} cacheKey="message-group-enterprise" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/message-sent-enterprise`} cacheKey="message-sent-enterprise" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/message-center-enterprise`} cacheKey="message-center-enterprise" component={ComponentParent}/>

        {/*region 用户*/}
        <CacheRoute path={`${match.url}/create-enterprise-details`} cacheKey="create-enterprise-details" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/create-user-certify`} cacheKey="create-user-certify"component={ComponentParent}/>
        <CacheRoute path={`${match.url}/edit-enterprise-details`} cacheKey="edit-enterprise-details" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/edit-user-certify`} cacheKey="edit-user-certify" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/edit-user-details`} cacheKey="user-details" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/enterprise-list-management`} cacheKey="enterprise-list-management" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/sms`} cacheKey="sms" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/user-details`} cacheKey="user-details" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/user-list-management`} cacheKey="user-list-management"  component={ComponentParent}/>
        <CacheRoute path={`${match.url}/user-list-management-private`} cacheKey="user-list-management-private"  component={ComponentParent}/>
        <CacheRoute path={`${match.url}/employee-list-management`} cacheKey="employee-list-management" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/employee-list-management-private`} cacheKey="employee-list-management-private"  component={ComponentParent}/>
        <CacheRoute path={`${match.url}/employee-verify-user-role`} cacheKey="employee-verify-user-role" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/edit-user-job`} cacheKey="edit-user-job" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/admin-edit-user`} cacheKey="admin-edit-user" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/verify-enterprise-auth-list`} cacheKey="verify-enterprise-auth-list" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/verify-enterprise-detail`} cacheKey="verify-enterprise-detail" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/verify-user-detail`} cacheKey="verify-user-detail" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/modify-user-password`}  cacheKey="modify-user-password" component={ComponentParent} />
        <CacheRoute path={`${match.url}/platform-resource-monitor`} cacheKey="platform-resource-monitor" component={ComponentParent}/>
        {/*<RouteWithErrorBoundary path={`${match.url}/apply-privileges`} component={UserRoleApply}/>*/}
        <CacheRoute path={`${match.url}/apply-platform-roles`} cacheKey="apply-platform-roles"  component={ComponentParent}/>
        <CacheRoute path={`${match.url}/apply-enterprise-roles`} cacheKey="apply-enterprise-roles" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/verify-user-role`} cacheKey="verify-user-role" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/function-roles`} cacheKey="function-roles" component={ComponentParent}/>


        <CacheRoute path={`${match.url}/current-users`} cacheKey="current-users" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/history-users`} cacheKey="history-users" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/login-statistics`} cacheKey="login-statistics" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/department-management`} cacheKey="department-management"  component={ComponentParent}/>

        {/*endregion*/}

        {/*region 租户资源*/}
        <CacheRoute path={`${match.url}/initialize-tenant-space`} cacheKey="initialize-tenant-space" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/namespace-verify-page`} cacheKey="namespace-verify-page" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/increase-quota`} cacheKey="increase-quota"  component={ComponentParent}/>
        <CacheRoute path={`${match.url}/space-apps-management`} cacheKey="space-apps-management"  component={ComponentParent}/>
        <CacheRoute path={`${match.url}/platform-space-apps-management`} cacheKey="platform-space-apps-management" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/enterprise-space-apps-management`} cacheKey="enterprise-space-apps-management" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/app-config-condition`} cacheKey="app-config-condition" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/apply-tsdatabase-space`} cacheKey="apply-tsdatabase-space" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/apply-bigdata-quota`} cacheKey="apply-bigdata-quota" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/apply-bigdata-quota`} cacheKey="apply-bigdata-quota" component={ComponentParent}/>
        {/*endregion*/}

        {/*region 权限*/}
        <CacheRoute path={`${match.url}/company-privilege`} cacheKey="company-privilege" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/assign-user-role`} cacheKey="assign-user-role" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/assign-platform-user-role`} cacheKey="assign-platform-user-role" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/privilege-role-config`} cacheKey="privilege-role-config" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/role-list`} cacheKey="role-list" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/user-role-config`} cacheKey="user-role-config" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/user-role-add`} cacheKey="user-role-add" component={ComponentParent}/>
        {/*endregion*/}
        {/*platform 权限*/}
        <RouteWithErrorBoundary path={`${match.url}/platform-privilege-role-config`} component={PlatformPrivilegeRoleConfig}/>
        <RouteWithErrorBoundary path={`${match.url}/platform-role-list`} component={PlatformRoleList}/>
        <RouteWithErrorBoundary path={`${match.url}/platform-user-role-config`} component={PlatformUserRoleConfig}/>
        <RouteWithErrorBoundary path={`${match.url}/platform-user-role-add`} component={PlatformUserRoleAdd}/>
        {/*end*/}

        {/*region 帮助管理*/}
        <CacheRoute path={`${match.url}/help-management`}cacheKey="help-management"  component={ComponentParent}/>
        {/*endregion*/}

        {/*region 算法*/}
        <CacheRoute path={`${match.url}/algorithm-category`} cacheKey="algorithm-category" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/algorithm-list`} cacheKey="algorithm-list" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/algorithm-add`} cacheKey="algorithm-add" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/algorithm-edit`} cacheKey="algorithm-edit" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/algorithm-view`} cacheKey="algorithm-view" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/algorithm-management`} cacheKey="algorithm-management" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/verify-algorithm-list`} cacheKey="verify-algorithm-list" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/verify-algorithm-detail`} cacheKey="verify-algorithm-detail" component={ComponentParent}/>
        {/*endregion*/}

        {/*region 应用*/}
        <CacheRoute path={`${match.url}/application-category`} cacheKey="application-category" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/application-verify-management`} cacheKey="application-verify-management" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/application-verify-platform`}  cacheKey="application-verify-platform" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/application-market-management`} cacheKey="application-market-management" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/application-management-enterprise`} cacheKey="application-management-enterprise" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/application-management-private`} cacheKey="application-management-private" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/application-management-platform`} cacheKey="application-management-platform" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/application-list`} cacheKey="application-list" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/application-add`} cacheKey="application-add" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/application-edit`} cacheKey="application-edit" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/module-add`} cacheKey="module-add" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/module-edit`} cacheKey="module-edit" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/version-add`} cacheKey="version-add" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/version-edit`} cacheKey="version-edit" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/resource-add`} cacheKey="resource-add" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/resource-edit`} cacheKey="resource-edit" component={ComponentParent}/>
        {/*endregion*/}

        {/*region 菜单管理*/}
        <CacheRoute path={`${match.url}/menu-management`} cacheKey="menu-management" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/menu-management-enterprise`} cacheKey="menu-management-enterprise" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/menu-role-config`} cacheKey="menu-role-config" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/menu-role-config-enterprise`} cacheKey="menu-role-config-enterprise" component={ComponentParent}/>
        {/*endregion*/}

        {/*region 数据采集*/}
        <CacheRoute path={`${match.url}/equipment-certify-list`} cacheKey="equipment-certify-list" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-certify-register`} cacheKey="equipment-certify-register" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-certify-destroy/:id`} cacheKey="equipment-certify-destroy" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-certify-verify`} cacheKey="equipment-certify-verify" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-type-list`} cacheKey="equipment-type-list" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-type-add`} cacheKey="equipment-type-add" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-type-edit/:id`} cacheKey="equipment-type-edit" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-management-list`} cacheKey="equipment-management-list" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-add`} cacheKey="equipment-add" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-edit/:id`} cacheKey="equipment-edit" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-detail/:id`} cacheKey="equipment-detail" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-config/:id`} cacheKey="equipment-config" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-data-view/:id`} cacheKey="equipment-data-view" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-log`} cacheKey="equipment-log" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-backup-list`} cacheKey="equipment-backup-list" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-backup-config/:id`} cacheKey="equipment-backup-config" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/equipment-backup-detail/:id`} cacheKey="equipment-backup-detail" component={ComponentParent}/>
        {/*endregion*/}

        {/*region 应用显示*/}
        <RouteWithErrorBoundary path={`${match.url}/application-iframe`} component={ConsoleApplicationPage}/>
        {/*endregion*/}

        {/*region 雇员邀请*/}
        <CacheRoute path={`${match.url}/user-invitation`} cacheKey="user-invitation" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/user-invitation-private`} cacheKey="user-invitation-private" component={ComponentParent}/>
        {/*endregion*/}
        <CacheRoute   path={`${match.url}/person-account`}  cacheKey="person-account" component={ComponentParent}/>
        {/*<CacheRoute path={`${match.url}/register-account`} cacheKey="verify" component={ComponentParent}/>*/}
        <CacheRoute path={`${match.url}/person-payment-confirmation`} cacheKey="person-payment-confirmation" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/enterprise-account`} cacheKey="enterprise-account" component={ComponentParent}/>

        {/*IoT NEW*/}
        <CacheRoute path={`${match.url}/iot/product`} cacheKey="iot/product" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/iot/device`} cacheKey="iot/device" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/iot/device-detail/:type/:id/:code/:protocol`} component={ComponentParent}/>
        <CacheRoute path={`${match.url}/iot/group`} component={ComponentParent}/>
        <CacheRoute path={`${match.url}/iot/data-push`} component={ComponentParent}/>

        {/*region 大数据开始*/}
        <CacheRoute path={`${match.url}/bigdata/projectList`} cacheKey="bigdata/projectList" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/bigdata/projectPanel`} cacheKey="bigdata/projectPanel" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/bigdata/dataset-management`} cacheKey="bigdata/dataset-management" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/bigdata/trained-model`} cacheKey="bigdata/trained-model" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/bigdata/my-hub`} cacheKey="bigdata/my-hub" component={ComponentParent}/>
        <CacheRoute path={`${match.url}/bigdata/extension`} cacheKey="bigdata/extension" component={ComponentParent}/>
        <CacheRoute exact path={`${match.url}/`}   cacheKey="consoleHome" component={ComponentParent}/>
      </CacheSwitch>
    </Console>
  </PrivateRoute>

)
const RouteWithErrorBoundary = (props) => {
  return (
    <ErrorBoundary key={props.location?.pathname}>
      <Route {...props} />
    </ErrorBoundary>
  );
};

//
// export default (onLogout) => (
//   <Route path="/" name="app" component={App}>
//     <IndexRoute component={Portal}>
//     </IndexRoute>
//
//     <Route path="common" component={PlatformFrame}>
//       {/*region 注册页面*/}
//       <Route path="register" component={Register}/>
//       <Route path="register-success" component={RegisterSuccess}/>
//       <Route path="register-verify" component={VerifyRegister}/>
//       <Route path="register-with-invitation-code" components={RegisterWithInvitationCode}/>
//       <Route path="verify-fail" component={VerifyFail}/>
//       <Route path="verify-success" component={VerifySuccess}/>
//       <Route path="logout" onEnter={onLogout}/>
//       <Route path="feedback" component={Feedback}/>
//       {/*endregion*/}
//
//       {/*region 登录页面*/}
//       <Route path="login" component={Login}/>
//       {/*endregion*/}
//
//       {/*region 重置密码与找回用户名*/}
//       <Route path="reset-password" component={ResetUserPasswordComponent}/>
//       <Route path="find-back-username" component={FindBackUsername}/>
//       {/*endregion*/}
//
//       {/*region 应用市场*/}
//       <Route path="application-market-portal" components={ApplicationMarketPortalPage}/>
//       <Route path="application-market-list" components={ApplicationMarketListPage}/>
//       <Route path="application-market-view" components={ApplicationMarketViewPage}/>
//       {/*endregion*/}
//
//       {/*region 租户资源*/}
//       <Route path="application-deploy" components={DeployMarketAppPage}/>
//       {/*endregion*/}
//
//       {/*region 用户职务信息修改*/}
//
//       {/*endregion*/}
//
//       {/*region 算法*/}
//       <Route path="algorithm-library" components={AlgorithmLibraryPage}/>
//       {/*endregion*/}
//       {/*region 大数据展示页面*/}
//       <Route path="bigdata-show" components={DataShowTempPage}/>
//       {/*endregion*/}
//       {/*region 新闻页面*/}
//       <Route path="news" components={NewsComponent}/>
//       {/*endregion*/}
//
//       {/*region 解决方案页面*/}
//       <Route path="solution" components={SolutionComponent}/>
//       {/*endregion*/}
//
//       {/*region 帮助文档*/}
//       <Route path="help-home" component={HelpHome}/>
//       <Route path="help-details" component={HelpDetails}/>
//       <Route path="help-filter" component={HelpFilter}/>
//       {/*endregion*/}
//
//       {/*region 页脚*/}
//       <Route path="about-cascloudwing" component={AboutCascloudwing}/>
//       <Route path="contact-us" component={ContactUs}/>
//       <Route path="pre-sale-consulting" component={PreSaleConsulting}/>
//       <Route path="advice-and-feedback" component={AdviceFeedback}/>
//       <Route path="legal-agreements" component={LegalAgreements}/>
//       <Route path="solutions" component={Solutions}/>
//       <Route path="customer-case" component={CustomerCase}/>
//       <Route path="nhi" component={Nhi}/>
//       <Route path="rgb" component={Rgb}/>
//       <Route path="sysmed" component={Sysmed}/>
//       <Route path="announcement" component={Announcement}/>
//       {/*region 页脚*/}
//     </Route>
//
//     {/*region 控制台*/}
//     <Route path="console" name="console" component={Console}>
//       <IndexRoute component={ConsoleHome}/>
//       <Route path="message-role-assign" components={MessageRoleAssignPage}/>
//       <Route path="message-type" components={MessageTypePage}/>
//       <Route path="message-sent" components={MessageSentPage}/>
//       <Route path="message-receive" components={ReceiveMessagePage}/>
//       <Route path="message-create" components={MessageCreate}/>
//       <Route path="message-detail-page/:id/:type" components={MessageDetailPage}/>
//
//       <Route path="message-center" component={MessageCenter}/>
//       <Route path="message-detail" component={MessageDetail}/>
//       <Route path="message-new" component={MessageNew}/>
//
//       {/*region 用户*/}
//       <Route path="create-enterprise-details" components={CreateEnterpriseDetails}/>
//       <Route path="create-user-certify" components={CreateUserCertifyPage}/>
//       <Route path="edit-enterprise-details" components={EditEnterpriseDetailsPage}/>
//       <Route path="edit-user-certify" components={EditUserCertifyPage}/>
//       <Route path="edit-user-details" components={EditUserDetailsPage}/>
//       <Route path="enterprise-list-management" components={EnterpriseList}/>
//       <Route path="sms" component={SmsMessage}/>
//       <Route path="user-details" components={UserDetailsPage}/>
//       <Route path="user-list-management" components={UserList}/>
//       <Route path="employee-list-management" components={EmployeeListPage}/>
//       <Route path="edit-user-job" components={EditUserJob}/>
//       <Route path="verify-enterprise-auth-list" components={VerifyEnterpriseAuthList}/>
//       <Route path="verify-enterprise-detail" components={VerifyEnterpriseDetail}/>
//       <Route path="verify-user-detail" components={VerifyUserDetail}/>
//       <Route path="modify-user-password" components={ModifyUserPassword}/>
//       <Route path="platform-resource-monitor" components={PlatformResourceMonitorPage}/>
//       <Route path="apply-privileges" components={UserRoleApply}/>
//       <Route path="verify-user-role" components={VerifyUserRoleApply}/>
//
//       <Route path="current-users" component={CurrentUserStatistics}/>
//       <Route path="history-users" component={HistoryUserStatistics}/>
//       <Route path="login-statistics" component={UserLoginStatistics}/>
//       <Route path="department-management" component={DepartmentAndJobManagement}/>
//
//       {/*endregion*/}
//
//       {/*region 租户资源*/}
//       <Route path="initialize-tenant-space" components={InitializeTenantSpace}/>
//       <Route path="namespace-verify-page" components={NamespaceVerifyPage}/>
//       <Route path="increase-quota" components={IncreaseQuota}/>
//       <Route path="space-apps-management" component={SpaceAppsManagementPage}/>
//       <Route path="app-config-condition" component={AppConfigAndConditionPage}/>
//       <Route path="apply-tsdatabase-space" component={ApplyTsdatabaseSpacePage}/>
//       <Route path="apply-bigdata-quota" component={ApplyBigdataQuotaPage}/>
//       <Route path="show-database-service" component={ShowDatabaseServicePage}/>
//       {/*endregion*/}
//
//       {/*region 权限*/}
//       <Route path="company-privilege" component={CompanyPrivilege}/>
//       <Route path="assign-user-role" component={AssignUserRole}/>
//       <Route path="privilege-role-config" component={PrivilegeRoleConfig}/>
//       <Route path="role-list" component={RoleList}/>
//       <Route path="user-role-config" component={UserRoleConfig}/>
//       <Route path="user-role-add" component={UserRoleAdd}/>
//       {/*endregion*/}
//
//       {/*region 帮助管理*/}
//       <Route path="help-management" component={HelpManagement}/>
//       {/*endregion*/}
//
//       {/*region 算法*/}
//       <Route path="algorithm-category" components={AlgorithmCategoryPage}/>
//       <Route path="algorithm-list" components={AlgorithmListPage}/>
//       <Route path="algorithm-add" components={AlgorithmAddPage}/>
//       <Route path="algorithm-edit" components={AlgorithmEditPage}/>
//       <Route path="algorithm-view" components={AlgorithmViewPage}/>
//       <Route path="algorithm-management" components={AlgorithmManagementPage}/>
//       <Route path="verify-algorithm-list" components={VerifyAlgorithmListPage}/>
//       <Route path="verify-algorithm-detail" components={VerifyAlgorithmDetailPage}/>
//       {/*endregion*/}
//
//       {/*region 应用*/}
//       <Route path="application-category" components={ApplicationCategoryPage}/>
//       <Route path="application-verify-management" components={ApplicationVerifyPage}/>
//       <Route path="application-market-management" components={ApplicationMarketManagementPage}/>
//       <Route path="application-management-enterprise" components={ApplicationManagementEnterprisePage}/>
//       <Route path="application-management-private" components={ApplicationManagementPrivatePage}/>
//       <Route path="application-list" components={ApplicationListPage}/>
//       <Route path="application-add" components={ApplicationAddPage}/>
//       <Route path="application-edit" components={ApplicationEditPage}/>
//       <Route path="module-add" components={ModuleAddPage}/>
//       <Route path="module-edit" components={ModuleEditPage}/>
//       <Route path="version-add" components={VersionAddPage}/>
//       <Route path="version-edit" components={VersionEditPage}/>
//       <Route path="resource-add" components={ResourceAddPage}/>
//       {/*endregion*/}
//
//       {/*region 菜单管理*/}
//       <Route path="menu-management" component={MenuManagementPage}/>
//       <Route path="menu-role-config" component={RoleConfigManagementPage}/>
//       {/*endregion*/}
//
//       {/*region 数据采集*/}
//       <Route path="equipment-certify-list" component={EquipmentCertifyListPage}/>
//       <Route path="equipment-certify-register" component={EquipmentCertifyRegisterPage}/>
//       <Route path="equipment-certify-destroy" component={EquipmentCertifyDestroyPage}/>
//       <Route path="equipment-certify-verify" component={EquipmentCertifyVerifyPage}/>
//       <Route path="equipment-type-list" component={EquipmentTypeListPage}/>
//       <Route path="equipment-type-add" component={EquipmentTypeAddPage}/>
//       <Route path="equipment-type-edit" component={EquipmentTypeEditPage}/>
//       <Route path="equipment-management-list" component={EquipmentListPage}/>
//       <Route path="equipment-add" component={EquipmentAddPage}/>
//       <Route path="equipment-edit" component={EquipmentEditPage}/>
//       <Route path="equipment-detail" component={EquipmentDetailPage}/>
//       <Route path="equipment-config" component={EquipmentConfigPage}/>
//       <Route path="equipment-data-view" component={EquipmentDataViewPage}/>
//       <Route path="equipment-log" component={EquipmentLogPage}/>
//       <Route path="equipment-backup-list" component={EquipmentBackupListPage}/>
//       <Route path="equipment-backup-config" component={EquipmentBackupConfigPage}/>
//       <Route path="equipment-backup-detail" component={EquipmentBackupDetailPage}/>
//       {/*endregion*/}
//
//       {/*region 应用显示*/}
//       <Route path="application-iframe" component={ConsoleApplicationPage}/>
//       {/*endregion*/}
//       {/*region 雇员邀请*/}
//       <Route path="user-invitation" component={UserInvitationPage}/>
//       {/*endregion*/}
//       <Route path="person-account" components={PersonAccountManagement}/>
//       <Route path="enterprise-account" components={EnterpriseAccountManagement}/>
//
//
//       {/*region 大数据开始*/}
//       <Route path="bigdata/projectList" component={ProjectList}/>
//       <Route path="bigdata/projectPanel" component={ProjectPanel}/>
//       <Route path="bigdata/dataset-management" components={DataSetManagementComponent}/>
//       <Route path="bigdata/trained-model" components={TrainedModelPage}/>
//       <Route path="bigdata/my-hub" component={MyHubPage}/>
//       <Route path="bigdata/extension" component={ExtensionPage}/>
//       {/*region 大数据结束*/}
//     </Route>
//     {/*endregion*/}
//     {/*region 异常*/}
//     <Route path="/exception/403" component={Exception403}/>
//     <Route path="/exception/404" component={Exception404}/>
//     <Route path="/exception/415" component={Exception415}/>
//     <Route path="/exception/500" component={Exception500}/>
//     {/*endregion*/}
//
//     {/*region 大数据*/}
//     <Route path="/algorithm/trained-model" components={TrainedModelPage}/>
//     <Route path="/algorithm/lhdTest" components={LhdTest}/>
//     <Route path="/algorithm/joint" components={JointTest}/>
//     <Route path="/algorithm/poc" components={Poc}/>
//     <Route path="/algorithm/projectPoc" components={ProjectPoc}/>
//     {/*region 大数据*/}
//
//     <Route path="algorithm-category" components={AlgorithmCategoryPage}/>
//     <Route path="algorithm-list" components={AlgorithmListPage}/>
//     <Route path="algorithm-add" components={AlgorithmAddPage}/>
//     <Route path="algorithm-edit" components={AlgorithmEditPage}/>
//     <Route path="algorithm-view" components={AlgorithmViewPage}/>
//     <Route path="algorithm-management" components={AlgorithmManagementPage}/>
//     <Route path="verify-algorithm-list" components={VerifyAlgorithmListPage}/>
//     <Route path="verify-algorithm-detail" components={VerifyAlgorithmDetailPage}/>
//
//     {/*region 咨询反馈*/}
//     <Route path="/feedback" component={Feedback}/>
//     {/*region 咨询反馈*/}
//
//     {/*region 隐私政策*/}
//     <Route path="privacy-policy" component={PrivacyPolicy}/>
//     <Route path="phone-farmer-privacy-policy" component={PhoneFarmerPrivacyPolicy}/>
//     {/*region 隐私政策*/}
//
//
//     <Route path="login-validate" component={LoginWithMobile}/>
//
//
//     {/*保持在最后 不要修改*/}
//     <Route path=":domain" component={Portal}/>
//   </Route>
// );
